import { render, staticRenderFns } from "./StarBlock.vue?vue&type=template&id=5f6a38c4&scoped=true"
import script from "./StarBlock.vue?vue&type=script&lang=js"
export * from "./StarBlock.vue?vue&type=script&lang=js"
import style0 from "./StarBlock.vue?vue&type=style&index=0&id=5f6a38c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a38c4",
  null
  
)

export default component.exports